import RiImageLine from '@ben/icons/image-line';
import { useImageUploadState } from '@ben/orion/hooks/use-image-upload';
import { RichTextEditor, useRichTextEditorContext } from '@mantine/tiptap';
import type { ChangeEvent } from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import RIcon from '../remix-icon/remix-icon';

export interface ImageUploadControlProps {
  onImageUpload: (file: File) => Promise<string>;
}

const ImageUploadControl = ({ onImageUpload }: ImageUploadControlProps) => {
  const { editor } = useRichTextEditorContext();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { uploadImage, isUploading } = useImageUploadState(onImageUpload);
  const { t } = useTranslation();
  const handleImageSelect = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const dataUrl = await uploadImage(file);

    editor?.commands.setImage({ src: dataUrl });

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleImageSelect}
      />
      <RichTextEditor.Control
        onClick={() => fileInputRef.current?.click()}
        aria-label={t('imageUpload.uploadImage', 'Upload image')}
        title={t('imageUpload.uploadImage', 'Upload image')}
        disabled={isUploading}
      >
        <RIcon icon={RiImageLine} size="sm" />
      </RichTextEditor.Control>
    </>
  );
};

export default ImageUploadControl;
